import { shopScene } from '../shopkit.js';

/** 汤池：花几文钱泡一泡，一身灰就跟着汗水走了。 */
export const onsenDoc = shopScene({
  id: 'onsen',
  name: '汤池',
  shop: 'onsen',
  owner: '堂倌',
  desc: '水汽蒸腾，泡进去一身灰就跟着汗水走了。',
  w: 22, h: 18,
  floor: '~',
  counters: [{ gx: 8, gy: 3, len: 4, kind: 'onsen' }],
  props: [
    { type: 'bathtub', gx: 12, gy: 10 },
    { type: 'changing_bench', gx: 4, gy: 8 },
    { type: 'changing_bench', gx: 5, gy: 8 },
    { type: 'water_trough', gx: 17, gy: 11 },
    { type: 'refuse_bin', gx: 3, gy: 14 },
    { type: 'straw_mat', gx: 8, gy: 14 },
  ],
  portals: [
    { to: 'main_street', gx: 11, gy: 17, spawn: [31, 9], label: '回主街' },
  ],
});

export default onsenDoc;
